import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Menu } from 'semantic-ui-react';
import BillingFXSettingV8 from './BillingFXSettingV8';
import BillingPriceSettingV8 from './BillingPriceSettingV8';
import OpenLuxPricingSettingV1012 from './OpenLuxPricingSettingV1012';
import { isRoot } from '../helpers';

const BillingSettingV8 = () => {
  const { t, i18n } = useTranslation();
  const [activeView, setActiveView] = useState('prices');
  const views = useMemo(
    () => [
      {
        key: 'prices',
        icon: 'tags',
        label: t('setting.billing.navigation.prices'),
      },
      {
        key: 'fx',
        icon: 'exchange',
        label: t('setting.billing.navigation.fx'),
      },
      ...(isRoot()
        ? [
            {
              key: 'openlux',
              icon: 'sliders horizontal',
              label: (i18n?.language || 'zh').startsWith('zh')
                ? 'OpenLux 回执结算'
                : 'OpenLux settlement',
            },
          ]
        : []),
    ],
    [t, i18n?.language]
  );

  return (
    <>
      <Menu secondary pointing stackable>
        {views.map((view) => (
          <Menu.Item
            key={view.key}
            active={activeView === view.key}
            onClick={() => setActiveView(view.key)}
          >
            <Icon name={view.icon} />
            {view.label}
          </Menu.Item>
        ))}
      </Menu>
      {activeView === 'prices' && <BillingPriceSettingV8 />}
      {activeView === 'fx' && <BillingFXSettingV8 />}
      {activeView === 'openlux' && isRoot() && <OpenLuxPricingSettingV1012 />}
    </>
  );
};

export default BillingSettingV8;
